import { jwtDecode } from 'jwt-decode'
import { useMemo } from 'react'
import { getXPlatformToken } from '../../utils/cookie'
import { wordPressHost } from '../../utils/location'

export function CosignAuthValidator() {
  const xPlatformToken = getXPlatformToken()
  const decoded = useMemo(() => xPlatformToken ? jwtDecode<{ platformUid?: string }>(xPlatformToken) : null, [xPlatformToken])
  const shouldShow404 = !decoded?.platformUid

  if (shouldShow404) {
    window.location.href = `${wordPressHost}/my-account/`
  }

  return null
}
